import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { expenseDetails } from "../../../core/data/json/expenseDetails";
import Table from "../../../core/common/dataTable/index";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { formatDate } from "../../../core/utils/FormatData";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllExpenses } from "../../../core/data/redux/payroll/Accounting/expenses/expenseActions";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {
  fetchAllExpensesReport,
  fetchAllExpensesReportCount,
  fetchAllRequestCount,
} from "../../../core/data/redux/reports/expenses_report/expenses.Action";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { OverTime_Report, OverTime_Report_summary } from "../../../core/data/redux/reports/overtime_report/overtime.Action";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { OverTime_Report_monthly } from "../../../core/data/redux/reports/overtime_report/overtime.Action";

interface OverTimeProps {
  showOnlyTable?: boolean;
}
const OverTimeReport: React.FC<OverTimeProps> = ({showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [chartdata, setchartdata] = useState<any[]>([]);
  const [count, setcount] = useState<any>("");
  const [request, setrequest] = useState<any>([]);


  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [employee, setEmployee] = useState("");
  const [department, setDepartment] = useState("");


  const handleSearch = () => {
    dispatch(OverTime_Report_monthly({ month: month, year: year }))
      .then((res) => {
        setchartdata(res.payload.data)
      })
  };


  useEffect(() => {
    dispatch(OverTime_Report_summary({}))
    .then((res) => {
      setcount(res.payload.data)
    })
    
  }, [dispatch]);

  const data = chartdata ? chartdata : [];

  function filterOvertimeData(data: any[]) {
  return data.map(item => ({
    EmployeeName: item.EmployeeName || "N/A",
    Department: item.DepartmentName || "N/A",
    Year: item.Year || "N/A",
    Month: item.Month || "N/A",
    MonthlyOvertime: item.MonthlyOvertime || "00:00:00"
  }));
}


  const data2 = filterOvertimeData(data)

  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, chartdata, selectedSort, selectedYear]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, chartdata, selectedYear]);

  

  useEffect(() => {
    const expensePerMonth = new Array(12).fill(0);

    if (chartdata && chartdata.length > 0) {
      chartdata.forEach(({ month, total_amount }: any) => {
        expensePerMonth[month - 1] = parseFloat(total_amount);
      });
    }

    setexpensechart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: expensePerMonth,
        },
      ],
    }));
  }, [chartdata, dispatch]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(OverTime_Report(selectedYear))
    .then((res) => {
       setrequest(res.payload.data)
    })
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  useEffect(() => {
  if (request && request.length > 0) {
    
    const monthlyData = new Array(12).fill(0);

   
    request.forEach((item: any) => {
      const monthIndex = item.Month - 1;
      monthlyData[monthIndex] = item.totalOvertimeHours;
    });

   
    setexpensechart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          name: "Overtime Hours",
          data: monthlyData,
        },
      ],
    }));
  }
}, [request]);


  //New Chart
  const [expensechart, setexpensechart] = useState<any>({
    series: [
      {
        name: "Expenses",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 190,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#FF9F43"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "",
      align: "left",
    },
    // grid: {
    //   row: {
    //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
    //     opacity: 0.5
    //   },
    // },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 200,
      tickAmount: 5,
      labels: {
        offsetX: -15,
        formatter: (val: number) => {
          return val / 1 + "Hrs";
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  const [paymentreport, setpaymentreport] = useState<any>({
    series: [],
    chart: {
      type: "donut",
    },
    colors: ["#0DCAF0", "#FD3995", "#AB47BC"],
    labels: ["Pending", "Approved", "Rejected"],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        stroke: {
          show: true,
          width: 10,
          colors: ["#FFFFFF"],
        },
        donut: {
          size: "80%",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    annotations: {
      position: "front",
      style: {
        fontSize: "24px",
        fontWeight: "bold",
        color: "#000000",
      },
      text: {
        text: "+14%",

        background: {
          enabled: true,
          foreColor: "#FFFFFF",
          border: "#000000",
          borderWidth: 1,
          borderRadius: 2,
          opacity: 0.7,
        },
      },
      x: "50%", 
      y: "50%", 
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  });

if (showOnlyTable) {
  return (
  <div className="custom-table border rounded shadow-sm w-100">
                  <table className="table table-striped table-bordered m-0 w-100">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th className="p-2 text-center">Employee ID</th>
                        <th className="p-2">Employee Name</th>
                        <th className="p-2">Department</th>
                        <th className="p-2 text-center">Year</th>
                        <th className="p-2 text-center">Month</th>
                        <th className="p-2 text-center">Monthly Overtime</th>
                      </tr>
                    </thead>
                    <tbody>
                      {chartdata
                        .filter((row) => (employee ? row.EmployeeID === parseInt(employee) : true))
                        .filter((row) => (department ? row.DepartmentName === department : true))
                        .map((row: any, index) => (
                          <tr key={index}>
                            <td className="p-2 text-center">{row.EmployeeID}</td>
                            <td className="p-2">{row.EmployeeName}</td>
                            <td className="p-2">{row.DepartmentName}</td>
                            <td className="p-2 text-center">{row.Year}</td>
                            <td className="p-2 text-center">{row.Month}</td>
                            <td className="p-2 text-center">{row.MonthlyOvertime?.split(".")[0]}</td>
                          </tr>
                        ))}

                      {chartdata.filter(
                        (row) =>
                          (employee ? row.EmployeeID === parseInt(employee) : true) &&
                          (department ? row.DepartmentName === department : true)
                      ).length === 0 && (
                          <tr>
                            <td colSpan={6} className="text-center p-3 text-muted">
                              No Data Found
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
  );
}

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Overtime Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Administration</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Overtime Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Overtime_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Overtime_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/total-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                           Overtime Hours
                          </span>
                          <h5>{count ? count?.[0].totalOvertimeHours : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                        >
                          <span className="text-primary">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +20.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/approved-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                           Pending
                          </span>
                          <h5>{count ? count?.[0].totalPendingRequest : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                        >
                          <span className="text-success">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +17.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/pending-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Rejected
                          </span>
                          <h5>{count ? count?.[0].rejectedOvertimeRequest : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/reject-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Approved
                          </span>
                          <h5>{count ? count?.[0].approvedOvertimeRequest : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                        >
                          <span className="text-danger">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    -10.17%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-area-line text-danger" />
                      </span>
                      <h5>Overtime </h5>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="expense-analysis"
                    options={expensechart}
                    series={expensechart.series}
                    type="area"
                    height={193}
                  />
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Overtime List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              </div>
            </div>
            <div className="card-body p-0">
              <Container className="mt-4">
                {/* Search Filters Row */}
                <Row className="mb-3 align-items-end">
                  {/* Year */}
                  <Col md={3}>
                    <Form.Label>Year</Form.Label>
                    <Form.Select value={year} onChange={(e) => setYear(e.target.value)}>
                      <option value="">Select Year</option>
                      {["2023", "2024", "2025"].map((yr) => (
                        <option key={yr} value={yr}>
                          {yr}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  {/* From Month */}
                  <Col md={3}>
                    <Form.Label>Month</Form.Label>
                    <Form.Select value={month} onChange={(e) => setMonth(e.target.value)}>
                      <option value="">Select Month</option>
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {new Date(0, i).toLocaleString("default", { month: "long" })}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  {/* Search Button */}
                  <Col md={3}>
                    <Button
                      variant="primary"
                      onClick={handleSearch}
                      className="w-100"
                    >
                      🔍 Search
                    </Button>
                  </Col>
                </Row>

                {/* Custom Table */}
                <div className="custom-table border rounded shadow-sm w-100 p-3 mb-4 bg-light">
                  <Row className="g-3 align-items-end">
                    {/* Employee Filter */}
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label className="fw-bold text-dark">Filter by Employee</Form.Label>
                        <Form.Select
                          value={employee}
                          onChange={(e) => setEmployee(e.target.value)}
                          className="shadow-sm"
                        >
                          <option value="">All Employees</option>
                          {chartdata.map((row: any) => (
                            <option key={row.EmployeeID} value={row.EmployeeID}>
                              {row.EmployeeName}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {/* Department Filter */}
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label className="fw-bold text-dark">Filter by Department</Form.Label>
                        <Form.Select
                          value={department}
                          onChange={(e) => setDepartment(e.target.value)}
                          className="shadow-sm"
                        >
                          <option value="">All Departments</option>
                          {[...new Set(chartdata.map((row: any) => row.DepartmentName))].map((dept: any) => (
                            <option key={dept} value={dept}>
                              {dept}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                {/* Table */}
                <div className="custom-table border rounded shadow-sm w-100">
                  <table className="table table-striped table-bordered m-0 w-100">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th className="p-2 text-center">Employee ID</th>
                        <th className="p-2">Employee Name</th>
                        <th className="p-2">Department</th>
                        <th className="p-2 text-center">Year</th>
                        <th className="p-2 text-center">Month</th>
                        <th className="p-2 text-center">Monthly Overtime</th>
                      </tr>
                    </thead>
                    <tbody>
                      {chartdata
                        .filter((row) => (employee ? row.EmployeeID === parseInt(employee) : true))
                        .filter((row) => (department ? row.DepartmentName === department : true))
                        .map((row: any, index) => (
                          <tr key={index}>
                            <td className="p-2 text-center">{row.EmployeeID}</td>
                            <td className="p-2">{row.EmployeeName}</td>
                            <td className="p-2">{row.DepartmentName}</td>
                            <td className="p-2 text-center">{row.Year}</td>
                            <td className="p-2 text-center">{row.Month}</td>
                            <td className="p-2 text-center">{row.MonthlyOvertime?.split(".")[0]}</td>
                          </tr>
                        ))}

                      {chartdata.filter(
                        (row) =>
                          (employee ? row.EmployeeID === parseInt(employee) : true) &&
                          (department ? row.DepartmentName === department : true)
                      ).length === 0 && (
                          <tr>
                            <td colSpan={6} className="text-center p-3 text-muted">
                              No Data Found
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>


              </Container>

            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default OverTimeReport;
